
import { Type } from "src/utils";

/**
 * 表示一个发送短信。
 * @enum
 * @version 1.0.0
 */
enum SmsType
{
    /**
     * 登入验证码
     * @member
     */
    loginCode = 1,

    /**
     * 注册验证码
     * @member
     */
    registerCode = 3,

    /**
     * 订单预约成功 
     * @member
     */
    orderSuccess = 5,

    /**
     * 检前一天 
     * @member
     */
    checkBeforeDay = 7,

    /**
     * 改约成功 
     * @member
     */
    changeReserve  = 9,

    /**
     * 取消订单
     * @member
     */
    cancelOrder  = 11
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(SmsType,
{
    loginCode:
    {
        alias: "登入验证码",
        description: ""
    },
    registerCode:
    {
        alias: "注册验证码",
        description: ""
    },
    orderSuccess:
    {
        alias: "订单预约成功",
        description: ""
    },
    checkBeforeDay:
    {
        alias: "检前一天",
        description: ""
    },
    changeReserve:
    {
        alias: "改约成功",
        description: ""
    },
    cancelOrder:
    {
        alias: "取消订单",
        description: ""
    }
});

export default SmsType;
